import { Box, Stack } from '@mui/material';
import { Debitwallet, Wallethistory } from 'assets/Icons';

import { useMediaQuery } from 'react-responsive';

const money = (value: number) =>
  value.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const ListElement = ({
  name,
  amount,
  time,
  specialization,
  amountState,
  status,
  reference,
  balanceBefore,
  balanceAfter
}: {
  name?: string;
  amount: number;
  time?: string;
  specialization?: string;
  amountState?: string;
  status?: string;
  reference?: string;
  balanceBefore?: number | null;
  balanceAfter?: number | null;
}) => {
  const breakPoint = useMediaQuery({
    query: '(max-width:  1024px)'
  });

  function formatDateString(dateString: any) {
    // Add null/undefined check
    if (!dateString) {
      return 'N/A';
    }

    // Try to parse ISO 8601 format (e.g., "2026-01-15T02:05:04+05:30")
    const isoRegex = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):/;
    const isoMatch = dateString.match(isoRegex);

    if (isoMatch) {
      const [, year, month, day, hour, minute] = isoMatch;
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const monthName = monthNames[parseInt(month, 10) - 1];

      // Convert to 12-hour format
      let hour12 = parseInt(hour, 10);
      const period = hour12 >= 12 ? 'pm' : 'am';
      if (hour12 > 12) {
        hour12 -= 12;
      } else if (hour12 === 0) {
        hour12 = 12;
      }

      return `${hour12}:${minute}${period}, ${day} ${monthName} ${year}`;
    }

    // Define a map for month names to their numeric values (legacy format support)
    const monthMap: any = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12'
    };

    // Extract the date and time parts using regex (legacy format)
    const regex = /(\d+)\s+of\s+(\w+),\s+(\d+)\s+at\s+(\d+):(\d+)(AM|PM)/;
    const match = dateString.match(regex);

    if (!match) {
      const parsed = new Date(dateString);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed.toLocaleString('en-NG', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        });
      }
      return '';
    }

    const [, day, monthName, year, hourStr, minute, period] = match;
    const month = monthMap[monthName];

    // Convert hour to 24-hour format if needed
    let hour = parseInt(hourStr, 10);
    if (period === 'PM' && hour !== 12) {
      hour += 12;
    } else if (period === 'AM' && hour === 12) {
      hour = 0;
    }

    // Format the hour back to 12-hour format for the desired output
    const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
    const formattedTime = `${formattedHour}:${minute}${period.toLowerCase()}`;

    // Format the date part
    const formattedDate = `${day}-${month}-${year}`;

    // Combine and return the formatted date and time
    return `${formattedTime}, ${formattedDate}`;
  }

  return (
    <div className="border-b border-dashed border-[#C8C6D7] py-2">
      <Box
        sx={{
          width: '100%',
          height: '50%'
        }}
        p={2}>
        <div className="flex justify-between gap-3 lg:grid lg:grid-cols-4 items-center">
          <Stack direction="row" spacing={2} alignItems="center" className="col-span-2">
            {/* <StyledBadge
              overlap="circular"
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              variant="dot"
            > */}
            {amountState === 'debit' ? <Debitwallet /> : <Wallethistory />}

            {/* </StyledBadge> */}

            <div>
              <p
                className={` text-sm md:text-base 
                text-darkerSecondary
                tracking-wide`}>
                {name}
              </p>
              <p
                className={`text-lightGrayPrimary
                 text-sm tracking-wide`}>
                {[
                  status,
                  specialization && specialization !== name ? specialization : '',
                  reference,
                  balanceBefore != null && balanceAfter != null
                    ? `₦${money(balanceBefore)} → ₦${money(balanceAfter)}`
                    : ''
                ]
                  .filter(Boolean)
                  .join(' · ')}
              </p>
            </div>
          </Stack>
          {breakPoint ? null : (
            <p
              className={` ${amountState === 'debit' ? 'text-[#FF0000]' : 'text-[#00B227]/90'}
            tracking-wider text-sm `}>
              {amountState === 'debit' ? '-' : '+'}&#8358;{money(amount)}
            </p>
          )}

          <Stack spacing={1} alignItems={'center'}>
            {breakPoint ? (
              <p
                className={` ${amountState === 'debit' ? 'text-[#FF0000]' : 'text-[#00B227]/90'}
            tracking-wider text-xs md:text-sm `}>
                {amountState === 'debit' ? '-' : '+'}&#8358;{money(amount)}
              </p>
            ) : null}
            <p
              className={`hidden lg:block  tracking-wide text-lightGrayPrimary
              } text-xs md:text-sm`}>
              {
                // breakPoint
                // ? formatDateString(
                //     time.split(',').map(({ part, index }: any) => (
                //       <span key={index}>
                //         {part.trim()} {/* Remove extra spaces */}
                //         <br /> {/* Break after each part */}
                //       </span>
                //     ))
                //   )
                //   :
                formatDateString(time)
              }
            </p>
          </Stack>
        </div>
      </Box>
    </div>
  );
};

export default ListElement;
